import React from 'react'

import ChangePassword from '../../../components/user/changePassword'
import { Switch, Route, Redirect } from 'react-router-dom'

import { LAYOUT_COMMON_USER_ROOT, LAYOUT_COMMON_USER_CHANGE_PASSWORD } from '../navigation'
export { LAYOUT_COMMON_USER_ROOT }

const Router = (props) => (
  <Switch>
    <Route
      path={LAYOUT_COMMON_USER_CHANGE_PASSWORD}
      render={(routeProps) => <ChangePassword {...props} {...routeProps} />}
    />
    <Redirect to='/' />
  </Switch>
)

export default Router
